module.exports = __webpack_public_path__ + "static/img/Post shore 3.0 meter.e54b87a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/Post shore 3.0 meter.jpg
// module id = 96
// module chunks = 1